// Modelo para hojas de ruta de paciente
export default class PatientHojaRuta {
    id=""
    patient={}
    date=""
    place=""
    role=""
    type=""
    caducity=""
    procedures=[]
    detail=""
    status=true
}



// WEBPACK FOOTER //
// ./src/model/PatientHojaRuta.js